<script setup lang="ts">

import {useCartStore} from "../cart.store";

const model = defineModel();
const option = {label: "Mini banners", price: "0.00"};

const {saveItemInCart} = useCartStore();

</script>

<template>
<div>
    <div c2c-0 class="tl cl">
        <div>
            <label c2c-1 class="rm">
                <input type="checkbox" :true-value="option" :false-value="{}" @change="saveItemInCart" v-model="model">
<!--                <span c2c-2 class="p-l-12 tb">Mini banner uncut +$15.99</span>-->
                <span c2c-3 class="p-l-12 tb">Mini banners</span> <span c2c-4 class="c-red tb p-l-6"> +FREE</span>
            </label>
        </div>

        <p c2c-5 class="fs-13">
            Mini banners are included for all players on your team.
        </p>

    </div>
</div>
</template>

<style scoped>

</style><style lang="scss" scoped>.tl[c2c-0] {
                        text-align: left;
                 }.cl[c2c-0] {
                        display: flex; flex-direction: column; align-items: flex-start;
                 }.rm[c2c-1] {
                        display: flex; flex-direction: row; align-items: center;
                 }.p-l-12[c2c-2] {
                        padding-left: 12px;
                 }.tb[c2c-2] {
                        font-weight: bold;
                 }.p-l-12[c2c-3] {
                        padding-left: 12px;
                 }.tb[c2c-3] {
                        font-weight: bold;
                 }.c-red[c2c-4] {
                        color: hsl(0, 100%, 50%);
                 }.tb[c2c-4] {
                        font-weight: bold;
                 }.p-l-6[c2c-4] {
                        padding-left: 6px;
                 }.fs-13[c2c-5] {
                        font-size: 13px;
                 }</style>